export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11079.df407701.jpg";